<template>
	<NuxtLoadingIndicator color="green"/>

	<div>
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>

		<UNotifications />
	</div>
</template>

<script setup lang="ts">
const SW_CLEANUP_SESSION_KEY = 'admin-sw-cleanup-v1'

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - ${useRuntimeConfig().public?.project_title}` : useRuntimeConfig().public?.project_title;
  }
})

onMounted(async () => {
  let shouldReload = false

  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations()
      if (registrations.length > 0) {
        const unregisterResults = await Promise.all(
          registrations.map((registration) => registration.unregister())
        )

        shouldReload = unregisterResults.some(Boolean) || shouldReload
      }
    } catch (error) {
      console.error('Ошибка удаления service worker:', error);
    }
  }

  if ('caches' in window) {
    try {
      const cacheKeys = await caches.keys()
      if (cacheKeys.length > 0) {
        await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)))
        shouldReload = true
      }
    } catch (error) {
      console.error('Ошибка очистки кэшей:', error);
    }
  }

  if (shouldReload && sessionStorage.getItem(SW_CLEANUP_SESSION_KEY) !== '1') {
    sessionStorage.setItem(SW_CLEANUP_SESSION_KEY, '1')
    window.location.reload()
    return
  }

  sessionStorage.removeItem(SW_CLEANUP_SESSION_KEY)
});
</script>
